module.exports = __webpack_public_path__ + "static/media/Ruff_gif_tv.86423021.gif";